// extracted by mini-css-extract-plugin
module.exports = {"departments":"zk","departmentHeading":"Ak","departmentSection":"Bk","departmentName":"Ck","departmentLink":"Dk","expandIcon":"Ek"};